import React , { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { useFormFields } from '../../util/hooks';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { formStyles } from '../../util/styles';
import Logo from '../../util/Logo';
import CssBaseline from '@mui/material/CssBaseline';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Link from '@mui/material/Link';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  logo: {
    marginTop: '-50px',
    padding: theme.spacing(0, 4, 4),
  },
}));

const ResetPassword = (props) => {
  const classes = formStyles();
  const baseClasses = useStyles();
  const [fields, handleFieldChange] = useFormFields({
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
	const [hasErrors, setHasErrors] = useState(false);
	const [error, setError] = useState("");
	const [hasSuccess, setHasSuccess] = useState(false);
	const [validLink, setValidLink] = useState(true);

  const handleSubmit = async (event) => {
    event.preventDefault();
		if (validLink) {
			try {
				let res = await axios.post('/api/resetpassword', {
					resetPasswordToken: props.token,
					password: fields.password
				});
				if (res && res.data.error){
					setHasErrors(true);
					setError(res.data.error);
					setHasSuccess(false);
				} else {
					setHasSuccess(true);
					setHasErrors(false);
				}
			} catch (error) {
				console.log(error);
				setHasErrors(true);
				let res = error.response;
				if (res && res.data && res.data.error) {
					setError(res.data.error);
				}
				else {
					setError(error.message);
				}
				setHasSuccess(false);
			}
		}
	}

  useEffect(() => {
		//Check if token has expired and validLink to false if not
		const checkToken = async () => {
			try {
				let res = await axios.post('/api/tokenvalid', {
					resetPasswordToken: props.token,
				});
				if (res && res.data.error){
					console.log(res.data.error);
					setValidLink(false);
				}
			}
			catch(error) {
				console.log(error);
				setValidLink(false);
			}
		}
		checkToken();
  }, [props.token]);

	if(validLink){
		return (
            <Container className={baseClasses.root} component="main" maxWidth="xs">
                <CssBaseline />
                <div className={baseClasses.logo}>
					<Logo />
				</div>
                <form
					className={classes.form}
					noValidate
					onSubmit={handleSubmit}
				>
					<Grid container spacing={2}>
						<Grid size={12}>
							<Typography align='center' variant="h4">
								Reset Password
							</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align='center' variant="body2">
								Enter your new password to reset
							</Typography>
						</Grid>
						<Collapse in={hasErrors}>
							<Alert severity="error">
								{error}
							</Alert>
						</Collapse>
						<Collapse in={hasSuccess}>
							<Alert severity="success">
								Your password has been reset.&nbsp;
								<Link href="/signin" variant="body2">
									Click here to signin.
								</Link>
							</Alert>
          	</Collapse>
						<Grid size={12}>
							<Typography
								variant="overline"
								className={classes.inputLabel}
							>
								Password
							</Typography>
							<TextField
								variant="outlined"
								fullWidth
								name="password"
								type={showPassword ? 'text' : 'password'}
								id="password"
								value={fields.password}
								onChange={handleFieldChange}
								InputProps={{
									classes: {
										root: classes.outlinedRoot,
									},
									endAdornment: (
										<>
											<InputAdornment position="end">
												<IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    onMouseDown={(event) =>
														event.preventDefault()
													}
                                                    size="large">
													{showPassword ? (
														<Visibility />
													) : (
														<VisibilityOff />
													)}
												</IconButton>
											</InputAdornment>
										</>
									),
								}}
							/>
						</Grid>
						<Grid size={12}>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								size="large"
								className={classes.submit}
							>
								Submit new password
							</Button>
						</Grid>
					</Grid>
				</form>
            </Container>
        );
	} else {
		return <h1 align='center'>Link no longer valid</h1>
	}

};

export default ResetPassword;
